import { render } from "./IndexOnboardingIMSPage.vue?vue&type=template&id=0e7362a2"
import script from "./IndexOnboardingIMSPage.vue?vue&type=script&lang=js"
export * from "./IndexOnboardingIMSPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__